import { FC } from "react";
import styled from "styled-components";
import { IconButton, transition } from "@evergis/ui";
import { IIconButtonProps } from "@evergis/ui/dist/molecules/IconButton/types";

import { GeoLocationMode } from "./types";

export const GeoLocationControl = styled<FC<IIconButtonProps & { mode?: GeoLocationMode }>>(IconButton)`
  transform: ${({ mode }) => mode !== GeoLocationMode.Watching && "rotate(-45deg)"};
  margin: ${({ mode }) => (mode !== GeoLocationMode.Watching ? "5px 0 0 3px" : "1px 0 0 2px")};
  transition: transform ${transition.hover};

  span:after {
    font-size: ${({ mode }) => (mode !== GeoLocationMode.Watching ? "0.9rem" : "1rem")};
    transition: font-size ${transition.hover};
  }
`;
GeoLocationControl.defaultProps = {
  kind: "geo_location",
  mode: GeoLocationMode.Off,
};
